import { Component } from 'react';
import NesGraphics from "../services/NesGraphics";

import "./PalettePreview.scss";

export class PalettePreview extends Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    render() {
        const s = (this.props.size || 8);
        return (
            <div className="palette-preview" style={{lineHeight: s + 'px'}}>
                {this.props.palette.map((entry, idx) => 
                    <div className="palette-color" key={'pal-' + idx + entry} style={{
                        backgroundColor: NesGraphics.getHexForColor(entry), 
                        width: s + 'px', 
                        height: s + 'px'
                    }} />
                )}
            </div>
        );
    }
}